import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SettingsService } from "./../settings.service";
import { PatientsService } from "../patients.service";
import { AppointmentsService } from "../appointments.service";
import { AnalyticsService } from "../analytics.service";

@Component({
    selector: "app-booking-by-room",
    templateUrl: "./booking-by-room.component.html",
    styleUrls: ["./booking-by-room.component.scss"],
    standalone: false
})
export class BookingByRoomComponent implements OnInit, OnDestroy {
  errorLoading = false;
  queryParams;
  doc;
  exam;
  patient;
  selected: moment.Moment | null;
  resendCodeTimer: number = 0;
  resendCodeDisabled: boolean = false;
  timerInterval: any;
  minDate: Date;
  activityHours = {
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
  };
  slots;
  confirmation: any = false;
  calendarReady = false;
  appointmentSuccesses = false;
  gid;
  maxDate = null;
  clinic;
  hmo;
  slotsDateSelected;
  Fetus;
  Price;
  AutoIndex = null;
  appointmentData = null;
  length;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private PatientsService: PatientsService,
    public SettingsService: SettingsService,
    public appointmentService: AppointmentsService,
    private analyticsService: AnalyticsService
  ) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 2);
  }

  myFilter = (d: moment.Moment): boolean => {
    const dateStr = d.format("YYYY-MM-DD"); // Format the date to a string in YYYY-MM-DD format
    const slotsForDate = this.slots[dateStr];
    return slotsForDate && slotsForDate.length > 0;
  };

  ngOnInit(): void {
    this.queryParams = this.route.snapshot.queryParams;
    this.Fetus = this.queryParams.F == "1" ? "עובר יחיד" : this.queryParams.F == "2" ? "תאומים" : null;
    if (!this.queryParams.g || !this.queryParams.p || !this.queryParams.h || !this.queryParams.e) {
      this.errorLoading = true;
      return;
    }

    this.SettingsService.getClinic(this.queryParams.g).subscribe(async (data: any) => {
      this.clinic = data;
      console.log(this.clinic);
      this.gid = this.clinic.GID;
      const examsTypes = await this.SettingsService.getExams(this.gid);
      this.exam = examsTypes.filter((exam) => exam.AutoIndex == this.queryParams.e)[0];
      this.length = this.Fetus == "תאומים" ? this.exam.LengthTwins : this.exam.Length;
      this.hmo = this.queryParams.h;
      this.AutoIndex = this.queryParams.a;
      if (this.AutoIndex) {
        this.appointmentData = await this.appointmentService.getAppointment(this.AutoIndex);
      }
      this.PatientsService.getPatientByPID(this.queryParams.p, this.gid, async (status) => {
        if (!status) return (this.errorLoading = true);
        this.patient = this.PatientsService.currentPatient;
        const today = new Date();
        this.minDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
        this.maxDate = new Date(this.minDate);
        this.maxDate.setMonth(this.maxDate.getMonth() + 3);

        if (
          this.SettingsService.categories["Pregnancy"].includes(this.exam.examType) ||
          this.SettingsService.categories["Fetal Echo"].includes(this.exam.examType)
        ) {
          const lmpDate = new Date(this.patient.LMP);
          const maxWeeks = this.exam.maxWeeks;
          if (maxWeeks) {
            this.maxDate = new Date(lmpDate.getTime() + maxWeeks * 7 * 24 * 60 * 60 * 1000);
          }
          const minWeeks = this.exam.minWeeks;
          if (minWeeks) {
            this.minDate = new Date(lmpDate.getTime() + minWeeks * 7 * 24 * 60 * 60 * 1000);
            const today = new Date();
            if (today > this.minDate) {
              this.minDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000); // Set minDate to 2 days from today
            }
          }
        }
        this.calculateAppointmentPrice();
        await this.getSlotsRange(
          this.setStartOfDay(this.minDate),
          this.setEndOfDay(this.maxDate),
          this.gid,
          this.length,
          this.queryParams.e
        );
      });
    });
  }

  setStartOfDay(date: Date): Date {
    const startOfDay = new Date(date);
    startOfDay.setHours(3, 0, 0, 0); // Set time to 00:00:00.000
    return startOfDay;
  }

  setEndOfDay(date: Date): Date {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999); // Set time to 23:59:59.999
    return endOfDay;
  }

  fetchActivityHours(UID, GID): void {
    this.SettingsService.getActivityHours(UID, GID).subscribe({
      next: (data) => {
        this.activityHours = data;
      },
      error: (err) => console.error("Failed to fetch activity hours", err),
    });
  }
  async getSlotsRange(minDate: Date, maxDate: Date, GID: string, slotsDuration: number, examType) {
    this.appointmentService
      .searchAvailableSlots({ minDate, maxDate, GID, slotsDuration, examType, byRoom: true })
      .subscribe({
        next: (response: any) => {
          this.slots = response.slots;
          const slotDates = Object.keys(this.slots);
          if (slotDates.length > 0) {
            this.minDate = new Date(slotDates.sort()[0]);
            this.maxDate = new Date(slotDates.sort()[slotDates.length - 1]);
          }
          this.calendarReady = true;
        },
        error: (error) => {
          this.slots = [];
        },
      });
  }
  onDateSelect(date: moment.Moment) {
    this.selected = date;
    const dateStr = this.selected.format("YYYY-MM-DD");
    this.slotsDateSelected = this.slots[dateStr];
    this.slotsDateSelected.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

    this.confirmation = false;
  }

  onSlotSelect(slot) {
    this.confirmation = slot;
  }

  saveAppointment() {
    const appointment = {
      appointmentDate: this.confirmation.slotTime,
      PID: this.queryParams.p,
      GID: this.gid,
      RID: this.confirmation.RID,
      duration: this.length,
      examTypeID: this.queryParams.e,
      SendSMS: true,
      ScheduleSMS: true,
      Fetus: this.queryParams.F,
      Price: this.Price,
      LMP: this.patient.LMP || null,
      Funding: this.queryParams.h,
    };
    this.appointmentService.addEvent(appointment).subscribe((data: any) => {
      if (data.AutoIndex) {
        this.appointmentSuccesses = true;
        this.analyticsService.updateVisit({ AppointmentId: data.AutoIndex }).subscribe({
          next: () => {
            // console.log("[Attribution] AppointmentId attached");
          },
        });
      }
    });
  }

  async updateAppointment() {
    this.appointmentData.aptTime = this.confirmation;
    await this.appointmentService.updateAppointment(this.appointmentData);
    this.appointmentSuccesses = true;
  }

  calculateAppointmentPrice() {
    this.Price = null;
    const appointmentData = {
      UID: null,
      GID: this.gid,
      examTypeId: this.exam.AutoIndex,
      Funding: this.queryParams.h,
      Fetus: this.queryParams.F,
      custom: this.exam.custom,
    };
    if (appointmentData["Funding"] !== "Private") {
      return;
      // appointmentData['Insurance']=this.queryParams.i
      // appointmentData['HMOName']=this.queryParams.hmo
    }
    this.appointmentService.calcAppointmentPrice(appointmentData).subscribe((data) => {
      if (data["price"]) {
        this.Price = data["price"];
      }
    });
  }

  getFundingText() {
    if (this.queryParams.h == "Private") {
      let text = "במימון פרטי";
      if (this.Price) {
        text += ` של  ${this.Price} ש"ח`;
      }
      return text;
    }
    if (this.queryParams.hmo == "Clalit") {
      return 'בהשתתפות קופ"ח כללית';
    }
    if (this.queryParams.hmo == "Maccabi") {
      return 'בהשתתפות קופ"ח מכבי';
    }
    if (this.queryParams.hmo == "Meuhedet") {
      return 'בהשתתפות קופ"ח מאוחדת';
    }
    if (this.queryParams.hmo == "Leumit") {
      return 'בהשתתפות קופ"ח לאומית';
    }

    return "";
  }

  exitWithoutAppointment(): void {
    const body = {
      GID: this.gid,
      ID: this.patient.ID,
      First: this.patient.First,
      Last: this.patient.Last,
      Mobile: this.patient.Mobile,
      Address: this.patient.Address,
      PID: this.patient.PID,
      UID: this.queryParams.u || this.doc?.UID,
      hasSeparation: this.clinic.hasSeparation || false,
      ExamType: this.exam.examName,
      Reason: 'User exited from booking without appointment'
    };

    this.PatientsService.savePatientsAbandonedProcesses(body).subscribe((result) => {
      if (result['status'] == 'ok') {
        this.router.navigate(['/exit-confirmation'], { queryParams: { p: this.patient.PID, g: this.gid } });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
}
